import { doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';

const clean = (value = '') => String(value || '').replace(/\s+/g, ' ').trim();

export const saveDocumentOrganization = async ({ sourceNoteId = '', displayTitle = '', confirmedOriginName = '', deps = {} } = {}) => {
  const sourceId = clean(sourceNoteId);
  const originName = clean(confirmedOriginName);
  if (!sourceId) throw new Error('The saved document could not be identified.');
  const update = deps.updateDoc || updateDoc;
  const document = deps.doc || doc;
  const timestamp = deps.serverTimestamp ? deps.serverTimestamp() : serverTimestamp();
  await update(document(deps.db || db, 'careSources', sourceId), {
    'metadata.source.displayTitle': clean(displayTitle),
    'metadata.source.confirmedOriginName': originName,
    'metadata.source.originConfirmedByCaregiver': Boolean(originName),
    updatedAt: timestamp,
  });
};
